import { Text, Icon, FlexProps, Flex } from 'pounceV2';
import React from 'react';
import { useTheme } from '@mui/material';
import type { IconType } from 'pounceV2/src/theme/icons';
import { NavigationLink } from '../types';

type NavLinkContentProps = Omit<NavigationLink, 'to'> & {
  isActive?: boolean;
};

const NavLinkContentV3 = ({
  icon,
  label,
  isSecondary,
  isActive,
  ...flexProps
}: NavLinkContentProps & FlexProps) => {
  const theme = useTheme();
  const backgroundColor = isActive
    ? theme.palette.componentTokens.selectMenuItems.color.item.background.row.selected
    : 'transparent';

  return (
    <Flex
      as="span"
      align="center"
      fontSize={
        isSecondary
          ? theme.palette.typographyTokens.fontSizes.sm
          : theme.palette.typographyTokens.fontSizes.base
      }
      px={isSecondary ? 2 : 4}
      py={3}
      sx={{
        backgroundColor,
        transition: 'background-color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        '&:hover': {
          backgroundColor:
            theme.palette.componentTokens.selectMenuItems.color.item.background.row.hover,
        },
        '&:focus': {
          backgroundColor:
            theme.palette.componentTokens.selectMenuItems.color.item.background.row.hover,
        },
      }}
      {...flexProps}
    >
      {icon && (
        <Icon
          type={icon as IconType}
          size={isSecondary ? 'small' : 'medium'}
          mr={isSecondary ? 4 : 3}
          ml={3}
        />
      )}
      <Text as="span">{label}</Text>
    </Flex>
  );
};

export default NavLinkContentV3;
